import axios from "axios";
import dayjs from "dayjs";
import { store } from "../../App";

const CREATE = "/orders/create";
const UPDATE = "/orders/update";

export const createOrder = async (data) => {
  try {
    let res
    if (data._id) {
      res = await axios.put(UPDATE + `/${data._id}`, data);
    } else {
      res = await axios.post(CREATE, data);
    }
    // store.dispatch({
    //   type: data._id ? onlySaveOnReducer ? "CREATE_ORDER" : "UPDATE_ORDER" : "CREATE_ORDER",
    //   data: onlySaveOnReducer ? data : res.data.data,
    // });
  } catch (e) {
    throw e;
  }
};

export const fetchOrders = async (data) => {
  try {
    const centerId = JSON.parse(localStorage.getItem("centerId")).centerId;

    const res = await axios.get(
      `/orders?centerId=${centerId}&startDate=${dayjs().format("YYYY-MM-DD")}`
    );
    store.dispatch({ type: "FETCH_ORDER", data: res.data });
  } catch (e) {
    throw e;
  }
};
